<div
  class="inline-flex items-center justify-center gap-2 rounded-full transition-all"
  [ngClass]="value > 0 ? 'bg-primary-border' : 'bg-secondary-background'"
>
  <button
    class="w-9 py-2 pr-2 pl-3"
    [disabled]="isDisabled || value <= minValue()"
    (click)="decrement()"
  >
    <img
      class="size-4"
      ngSrc="assets/icons/minus_icon_white.svg"
      alt=""
      height="16"
      width="16"
    />
  </button>
  <input
    class="w-auto rounded-xs bg-transparent text-center focus:bg-white focus:text-black"
    [ngClass]="{ 'text-white outline-none': value > 0 }"
    [disabled]="isDisabled"
    [ngModel]="value"
    [size]="value.toString().length"
    [min]="minValue()"
    [max]="maxValue()"
    (ngModelChange)="onValueChange($event)"
    (blur)="onBlur($event)"
    type="number"
  />
  <button
    class="w-9 py-2 pr-3 pl-2"
    [disabled]="isDisabled || value >= maxValue()"
    (click)="increment()"
  >
    <img
      class="size-4"
      ngSrc="assets/icons/plus_icon.svg"
      alt=""
      height="16"
      width="16"
    />
  </button>
</div>
